<span 
  class="status-badge" 
  [ngClass]="['badge-' + color, 'badge-' + size]">
  {{ text }}
</span>

